import { Api } from './js/AppApi';

Api.load({
  invert_mouse: false
});
